export const HEATMAP_ONBOARDING_TITLE = 'ヒートマップレポートの使い方'

export const HEATMAP_ONBOARDING_ISSUE_HREF = 'https://sitelead.notion.site/10ba1f34e38c80618ef1c22dac6ebebd#18aa1f34e38c8049ac78e5d4efacfc41'

export const HEATMAP_ONBOARDING_SLIDES = [
  {
    heading: 'ヒートマップに表示するWebサイトのデザインを更新できます',
    body: 'ヒートマップには、計測開始時のWebサイトのデザインが保存されます。<br>Webサイトのデザインを変更した場合は、「デザイン更新」から最新のデザインを取得できます。',
    image: '/images/heatmap_onboarding/hm_1.jpg'
  },
  {
    heading: '保存したデザインを切り替えて確認できます',
    body: 'Webサイトのデザインは、保存することができます。<br>Free・Basicプランでは最大1つ、Masterプラン以上では最大5つのデザインまで保存可能です。<br><br>保存したデザインを選択することで、過去のWebサイトデザインでもヒートマップを確認できます。<br>※最大数を超えたデザインは、古い順に削除されます。',
    image: '/images/heatmap_onboarding/hm_2.jpg'
  },
  {
    heading: '条件を指定してヒートマップを分析できます',
    body: 'セグメント機能では、クリック・離脱・訪問回数などの条件を指定することで、特定のユーザー行動に絞ったヒートマップを確認できます。',
    image: '/images/heatmap_onboarding/hm_3.jpg'
  },
  {
    heading: 'ヒートマップとあわせて各種指標を確認できます',
    body: 'PV数・FV離脱率・滞在時間などの数値を確認できます。<br><br>また、「並列表示」や「クリック一覧」を利用することで、複数のヒートマップやクリック箇所を比較しながら分析できます。',
    image: '/images/heatmap_onboarding/hm_4.png'
  },
  {
    heading: 'ヒートマップが表示されない場合はこちら',
    body: 'Webサイトのデザインが正しく表示されない場合や、ヒートマップについて不明点がある場合は、「ヒートマップが表示されない時」から確認できます。',
    image: null,
    issueHref: HEATMAP_ONBOARDING_ISSUE_HREF
  }
]
